export const INVALID = 'INVALID';
export const SEPARATOR = ';';
export const DNI = 'DNI';
